import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export function HeaderCourseDetailsModal() {
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="h5">{t('course_details') || 'Detalhes do Curso'}</Typography>
    </Box>
  )
}
